import React, { useState } from 'react'
import PaginatedList from '../../screen-templates/paginated-list'
import Item from '../list-item'
import useReflectionPrompts from '../../../hooks/use-reflection-prompts'

const ReflectionPromptsPaginatedList = ({
    limit = 10
}) => {
    const [ offset, setOffset ] = useState(0)
    const { reflectionPrompts, isLoading, total } = useReflectionPrompts({ offset, limit })
    return (
        <PaginatedList
            items = {reflectionPrompts}
            pageSize={limit}
            itemComponent={Item}
            total={total}
            offset={offset}
            loading={isLoading}
            onOffsetChange={setOffset}
            noneFoundMessage='No prompts found.'
        />
    )
}

export default ReflectionPromptsPaginatedList